import React from 'react';

import ToolbarButton from './ToolbarButton';

export type ToolbarButtonProps = {
  isMobile?: boolean;
  active?: boolean;
  disabled?: boolean;
  tooltip?: string;
  onClick: (e: $TSFixMe) => void;

  icon: any;
  dataHook?: string;
};

const IconToolbarButton = React.forwardRef<HTMLButtonElement | null, ToolbarButtonProps>(
  ({ isMobile = false, active, disabled, tooltip, onClick, icon, dataHook }, ref) => {
    const Icon = icon;

    return (
      <ToolbarButton
        ref={ref}
        tooltip={tooltip}
        isMobile={isMobile}
        active={active}
        disabled={disabled}
        onClick={onClick}
        dataHook={dataHook}
      >
        <Icon />
      </ToolbarButton>
    );
  }
);

export default IconToolbarButton;
